import { type SVGProps, forwardRef } from 'react';

export enum SvgSize {
  XSmall = 16,
  Small = 20,
  Medium = 24,
}

export enum SvgTypes {
  Filled = 'filled',
  Stroke = 'stroke',
}

export type SvgProps = Omit<SVGProps<SVGSVGElement>, 'ref'> & {
  size?: number | string | SvgSize;
  fill?: string;
  width?: number | string;
  height?: number | string;
  'data-testid'?: string;
  type?: SvgTypes;
};

export const Svg = forwardRef<SVGSVGElement, SvgProps>(function Svg(
  {
    children,
    size = 18,
    fill = 'none',
    width = size,
    height = size,
    viewBox,
    'data-testid': testId,
    ...properties
  },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      data-testid={testId}
      {...properties}
    >
      {children}
    </svg>
  );
});
